import { getBffBaseUrl } from '../environment-variables'
import { logger } from '../logging'
import { AnalyticsEvent } from './analytics-event-names'

interface TrackEventParams {
  event: AnalyticsEvent
  properties?: Record<string, string | number | boolean | object>
  clientAnonymousId?: string
}

/**
 * Track an analytics event via the BFF API (angel-com-api).
 * This is used when client-side analytics tracking is blocked or when
 * server-side tracking is preferred.
 *
 * @param params - The event tracking parameters
 * @returns Promise that resolves when the event is tracked
 */
export async function trackViaBff({ event, properties, clientAnonymousId }: TrackEventParams): Promise<void> {
  try {
    if (!clientAnonymousId) {
      logger().warn('Cannot track event via BFF: missing clientAnonymousId', { event })
      return
    }

    const response = await fetch(`${getBffBaseUrl()}/analytics/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event,
        properties: properties || {},
        clientAnonymousId,
      }),
    })

    if (!response.ok) {
      throw new Error(`Failed to track event: ${response.status} ${response.statusText}`)
    }
  } catch (error) {
    logger().error('Failed to track event via BFF', { error, event, properties })
    throw error
  }
}
